const distributorFinancePaths = new Set([
  '/workspace/distributor-customer-accounts',
  '/workspace/distributor-earnings',
  '/workspace/distributor-recharge-audit',
  '/workspace/distributor-settings',
  '/workspace/finance/details',
  '/workspace/finance/recharge',
]);

const distributorLoginOnlyPaths = new Set([
  '/workspace/distributor-customer-accounts',
  '/workspace/distributor-earnings',
  '/workspace/distributor-recharge-audit',
  '/workspace/distributor-settings',
]);

const financeLoginIdentityKey = 'financeLoginIdentity';
const distributorHomePath = '/workspace/finance/recharge';

export { distributorHomePath };

export function isDistributorFinanceRoute(path: string) {
  return distributorFinancePaths.has(stripQueryAndHash(path));
}

export function resolveFinanceLoginIdentity(
  currentPath: string,
  redirect?: unknown,
) {
  const redirectPath =
    typeof redirect === 'string' && redirect.length > 0
      ? safeDecodeURIComponent(redirect)
      : '';

  const path = redirectPath || currentPath;

  if (isDistributorLoginOnlyRoute(path)) {
    return 'distributor';
  }

  if (isDistributorFinanceRoute(path)) {
    return getStoredFinanceLoginIdentity() || 'merchant';
  }

  return 'merchant';
}

export function resolveFinanceRouteIdentity(path: string) {
  return isDistributorLoginOnlyRoute(path) ||
    (isDistributorFinanceRoute(path) &&
      getStoredFinanceLoginIdentity() === 'distributor')
    ? 'distributor'
    : 'merchant';
}

export function isDistributorLoginOnlyRoute(path: string) {
  return distributorLoginOnlyPaths.has(stripQueryAndHash(path));
}

export function rememberFinanceLoginIdentity(
  identity: 'distributor' | 'merchant',
) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(financeLoginIdentityKey, identity);
}

export function getStoredFinanceLoginIdentity() {
  if (typeof window === 'undefined') return undefined;
  const identity = window.localStorage.getItem(financeLoginIdentityKey);
  return identity === 'distributor' || identity === 'merchant'
    ? identity
    : undefined;
}

export function isStoredDistributorLogin() {
  return getStoredFinanceLoginIdentity() === 'distributor';
}

function safeDecodeURIComponent(value: string) {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function stripQueryAndHash(path: string) {
  return path.split(/[?#]/)[0] || path;
}
